import styled from "@emotion/styled"
import theme from "../../particles/Theme"

const StyledMobileMenu = styled.div`
  display: none;
  position: relative;

  .mobile-header {
    z-index: 2000;
    background: white;
  }

  .mobileMenu {
    position: absolute;
    top: -100vh;
    left: 0;
    height: 80vh;
    overflow: hidden;
    overflow-y: scroll;
    width: 100%;
    z-index: 1000;
    background: ${theme.colors.primary};
    transition: all 0.5s ease-in-out;

    ul {
      font-weight: 700;
      text-transform: uppercase;
      color: white;
      padding-left: 0;
      margin: 0;
      height: 150px;

      > li {
        list-style: none;
        border-bottom: 1px solid white;
        padding: 2rem;
      }

    }
  }

  .open {
    top: 120px;
  }

  button.hamburger {
    position: absolute;
    right: 4rem;
    top: calc(50% - 4rem);
    font-size: 8rem;
  }

  @media (max-width: ${theme.breakpoints[1]}) {
    display: block;
  }
`

export default StyledMobileMenu
